var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFooterDonation = function SvgIcFooterDonation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#585A64",
    d: "M2.761 8.29c.64-.164 1.557-.206 2.73-.053 2.258.294 3.308.774 5.106.659 1.439-.092 2.229-.982 2.444-1.416l.139.018c.205.398.362.828.46 1.284.619 2.899-1.361 5.78-4.422 6.434s-6.046-1.166-6.666-4.064a5.13 5.13 0 0 1 .21-2.862"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#585A64",
    d: "M10.815.854c.222 0 .401.181.4.403l-.007 2.12a.403.403 0 0 1-.403.402l-.574-.003-.004 1.142c2.105.808 3.586 2.764 3.578 5.046-.01 2.995-2.583 5.414-5.746 5.403-3.163-.01-5.719-2.448-5.709-5.443.008-2.281 1.503-4.227 3.612-5.021l.004-1.142-.573-.002a.4.4 0 0 1-.4-.402l.008-2.122c0-.222.18-.401.402-.4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIcFooterDonation;